import React, { useState, useRef, useEffect } from 'react'
import './Navbar.css'
import logo from '../../assets/Logo-2.jpg'
import {Link} from 'react-router-dom'
import 'bootstrap-icons/font/bootstrap-icons.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import Mobile from './Mobile';
library.add(fas)


const Navbar = () => {
  
  return (
    <div id="header" class="header d-flex align-items-center ">
        <div class="container-fluid container-xl position-relative d-flex align-items-center">
        <a href="/" class="logo d-flex align-items-center me-auto">
        <img src={logo} alt="" />
      </a>
      

      <nav id="navmenu" class="navmenu" expand="lg">
        <ul>
          <li class="dropdown"><a href="/"><span>Takshila VLSI</span> <i class="bi bi-chevron-down toggle-dropdown"></i></a>
            <ul>
              <li><a href="/about-us">About Us</a></li>
              <li><a href="/vision">Vision</a></li>
              <li><a href="/why-join-us">Why Join Us</a></li>
              <li><a href='https://www.takshila-vlsi.com/blog' target='_blank'>Blog</a></li>
              <li><a href="/apply-trainer/">Apply as Trainer</a></li>
            </ul>
          </li>
          <li class="dropdown"><a href="/courses"><span>Courses</span> <i class="bi bi-chevron-down toggle-dropdown"></i></a>
            <ul>
             
              <li class="dropdown"><a href="/product-category/vlsi-courses-for-freshers/"><span>For Freshers</span> <i class="bi bi-chevron-down toggle-dropdown"></i></a>
                <ul>
                <li><a href="/product/physical-design">Physical Design</a></li>
                <li><a href="/product/asic-verification/">ASIC Verification</a></li>
                <li><a href="/product/analog-layout-design/">Analog Layout Design</a></li>
                <li><a href="/product/design-for-test/">Design For Test</a></li>
                <li><a href="/product/analog-circuit-design/">Analog Circuit Design</a></li>
                <li><a href="/product/rtl-coding-fpga-design/">RTL Coding and FPGA Design</a></li>
                <li><a href="/product/embedded-systems-training/">Embedded Systems Training</a></li>
                </ul>
              </li>
              <li class="dropdown"><a href="/product-category/vlsi-courses-for-professionals/"><span>For Working Professionals</span> <i class="bi bi-chevron-down toggle-dropdown"></i></a>
                <ul>
                <li><a href="/product/physical-design-part-time/">Physical Design-Part Time</a></li>
                <li><a href="/product/asic-verification-part-time/">ASIC Verification-Part Time</a></li>
                <li><a href="/product/analog-layout-design-part-time/">Analog Layout Design-Part Time</a></li>
                <li><a href="/product/design-for-test-part-time/">Design For Test-Part Time</a></li>
                <li><a href="/product/analog-circuit-design/">Analog Circuit Design</a></li>
                <li><a href="/product/rtl-coding-fpga-design-part-time/">RTL Coding and FPGA Design-Part Time</a></li>
                <li><a href="/product/finfet-layout-design/">FINFET Layout Design Training</a></li>
                <li><a href="/product/uvm-training/">UVM Training</a></li>
                <li><a href="/product/perl-scripting/">PERL Scripting</a></li>
                </ul>
              </li>
              <li class="dropdown"><a href="/product-category/vlsi-online-courses/"><span>Online Courses</span> <i class="bi bi-chevron-down toggle-dropdown"></i></a>
                <ul>
                <li><a href="/product/physical-design-online/">Physical Design Online</a></li>
                <li><a href="/product/asic-verification-online/">ASIC Verification Online</a></li>
                <li><a href="/product/analog-layout-design-online/">Analog Layout Design Online</a></li>
                <li><a href="/product/design-for-test-dft-online/">Design For Test Online</a></li>
                <li><a href="/product/analog-circuit-design-online/">Analog Circuit Design Online</a></li>
                <li><a href="/product/rtl-coding-and-fpga-design-online/">RTL Coding and FPGA Design Online</a></li>
                <li><a href="/product/uvm-training-online/">UVM Training Online</a></li>
                </ul>
              </li>
              <li><a href="/course-videos/">Online Course Videos</a></li>
              <li><a href="/events/demo-class/">Free Demo Class</a></li>
              <li><a href="/events/1-day-free-vlsi-training/">1-Day Free VLSI Training</a></li>
               
            </ul>
          </li>
          <li><a href="/course-calendar">Course Calendar</a></li>
          <li class="dropdown"><a href="/corporate-trainings/"><span>Corporate</span> <i class="bi bi-chevron-down toggle-dropdown"></i></a>
            <ul>
              <li><a href="/academic/">Academic</a></li>
              
            </ul>
          </li>
          <li><a href="/placements">Placements</a></li>
          <li><a href="/contact-us/">Contact</a></li>
          <li><a href="https://www.takshila-vlsi.com/blog" target='_blank' rel="noopener noreferrer">Blog</a></li>
        </ul>

        {/*<i class="mobile-nav-toggle d-xl-none bi bi-list" aria-controls="navmenu"></i>*/}
       

    </nav>
    <Mobile/>
    

    
      <Link class="btn-getstarted" to="/register-now/">Get Demo Class <FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></Link>
        </div> 
        
  </div>
    
  )
}

export default Navbar